import { render, staticRenderFns } from "./SectionEditorDialog.vue?vue&type=template&id=fc88ccd4&scoped=true"
import script from "./SectionEditorDialog.vue?vue&type=script&lang=js"
export * from "./SectionEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./SectionEditorDialog.vue?vue&type=style&index=0&id=fc88ccd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc88ccd4",
  null
  
)

export default component.exports